module.exports = __webpack_public_path__ + "img/instruction-cocoa2-ios-01.0f740817.png";